import { NavSearchItem, searchNavigation as searchNav } from '@euroasiann/shared';

export const NAV_SEARCH_INDEX: NavSearchItem[] = [
  { label: 'Dashboard', path: '/dashboard', keywords: ['dashboard', 'home', 'overview'] },
  { label: 'Users', path: '/users', keywords: ['users', 'employees', 'staff'] },
  { label: 'Organizations', path: '/organizations', keywords: ['organizations', 'customers', 'vendors'] },
  { label: 'Onboarding', path: '/onboarding-data', keywords: ['onboarding', 'approval'] },
  { label: 'Licenses', path: '/licenses', keywords: ['licenses', 'subscription'] },
  { label: 'Roles & Permissions', path: '/roles', keywords: ['roles', 'permissions'] },
  { label: 'Assign Roles', path: '/assign-roles', keywords: ['assign roles', 'access'] },
  { label: 'Support Tickets', path: '/support/tickets', keywords: ['support', 'tickets'] },
  { label: 'Customer Support Chat', path: '/support/chat', keywords: ['chat', 'live support'] },
  { label: 'Incident Management', path: '/incidents', keywords: ['incidents', 'risk'] },
  { label: 'Analytics', path: '/analytics', keywords: ['analytics', 'reports'] },
  { label: 'API Docs', path: '/api-docs', keywords: ['api', 'swagger', 'openapi', 'documentation', 'rest'] },
  { label: 'Settings', path: '/settings', keywords: ['settings', 'preferences', 'display'] },
];

export function searchNavigation(query: string, limit = 8) {
  return searchNav(query, NAV_SEARCH_INDEX, limit);
}
